import React, { useEffect, useState } from "react";
import axios from "axios";
import { CSVLink } from "react-csv";

import CorcSelect from "components/utils/CorcSelect";
import BASE_API_URL from "const";

function Reports(props) {
  useEffect(() => {
    props.setNavLinks([
      { title: "Reports", url: "/reports", icon: "menu-report" },
    ]);

    // do we have permissions?
    if (props.userAuth.user.role !== "admin") {
      props.history.push("/studies");
      return;
    }
  }, []);

  return (
    <div className="home_header_container_class wide">
      <div className="content">
        <EmailReports {...props} />
      </div>
    </div>
  );
}

export default Reports;

function EmailReports(props) {
  const [emailsList, setEmailsList] = useState([]);
  const [studiesList, setStudiesList] = useState([]);
  const [centersList, setCentersList] = useState([]);

  const [studyFilterId, setStudyFilterId] = useState("");
  const [roleFilter, setRoleFilter] = useState("");

  const fetchStudies = async () => {
    props.setOverlayVisible((count) => count + 1);
    await axios.get(`${BASE_API_URL}/studies/`, { withCredentials: true }).then(
      (response) => {
        setStudiesList(response.data);
        props.setOverlayVisible((count) => count - 1);
      },
      (error) => {
        console.error(error);
        props.setOverlayVisible((count) => count - 1);
      },
    );
  };

  const fetchEmails = async () => {
    props.setOverlayVisible((count) => count + 1);

    let URL = `${BASE_API_URL}/users/email_export/`;

    if (studyFilterId !== "" && studyFilterId !== "-1") {
      URL = `${URL}?study_id=${encodeURIComponent(studyFilterId)}`;
    }

    if (roleFilter !== "" && roleFilter !== "-1") {
      URL = `${URL}${
        studyFilterId !== "" && studyFilterId !== "-1" ? "&" : "?"
      }role=${encodeURIComponent(roleFilter)}`;
    }

    await axios
      .get(URL, {
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      })
      .then(
        (response) => {
          setEmailsList(response.data.study_emails);
          setCentersList(response.data.center_emails);
          props.setOverlayVisible((count) => count - 1);
        },
        (error) => {
          console.error(error);
          props.setOverlayVisible((count) => count - 1);
        },
      );
  };

  useEffect(() => {
    fetchStudies();
    return () => setStudiesList([]);
  }, []);

  useEffect(() => {
    fetchEmails();
    return () => setEmailsList([]);
  }, [studyFilterId, roleFilter]);

  const headersCSV = [
    { label: "id", key: "id" },
    { label: "E-mail", key: "email" },
    { label: "Username", key: "username" },
    { label: "Name", key: "name" },
    { label: "Last Name", key: "last_name" },
    { label: "Role", key: "role" },
    { label: "Studies", key: "studies" },
  ];

  const centerHeadersCSV = [
    { label: "id", key: "id" },
    { label: "Study Name", key: "acronym" },
    { label: "Center Name", key: "study_site_num" },
    { label: "Study CORC E-mail", key: "corc_email" },
    { label: "PI Contact", key: "pi_contact_email" },
    { label: "PI Notification", key: "pi_notification_email" },
    { label: "Study Coordinator", key: "study_coordinator_email" },
    { label: "Other E-mails", key: "other_emails" },
  ];

  return (
    <div className="top-buttons">
      <div className="overview">
        <h2 className="text-shadow">Platform E-mails Export</h2>
      </div>
      <ul className="button-group left">
        <li>
          <StudiesDropdownFilter
            studiesList={studiesList}
            setFilterId={setStudyFilterId}
          />
        </li>
        <li>
          <ProfilesDropdownFilter setFilterRole={setRoleFilter} />
        </li>
      </ul>
      <ul className="button-group right">
        <li>
          <CSVLink
            data={centersList}
            headers={centerHeadersCSV}
            filename="study-contacts-export.csv"
            className="btn normal grey right"
            separator=";"
          >
            <span className="icon icon-list report"></span>
            Clinical Sites Contacts
          </CSVLink>
        </li>
        <li>
          <CSVLink
            className="btn normal grey right"
            data={emailsList}
            headers={headersCSV}
            filename={"emails-export.csv"}
            separator=";"
          >
            <span className="icon icon-list report"></span>
            Export{" "}
            {studyFilterId !== "" && studyFilterId !== "-1"
              ? "Study Contacts"
              : "All Contacts"}
          </CSVLink>
        </li>
      </ul>
    </div>
  );
}

function StudiesDropdownFilter(props) {
  const defaultOption = { label: "All Studies", value: "-1" };

  return (
    <CorcSelect
      id="study-select"
      containerStyles={{ width: "165px" }}
      name="study"
      options={[
        defaultOption,
        ...props.studiesList.map((s) => ({ label: s.acronym, value: s.id })),
      ]}
      onChange={(selectedOption) => props.setFilterId(selectedOption.value)}
      defaultValue={defaultOption}
    />
  );
}

function ProfilesDropdownFilter(props) {
  const defaultOption = { label: "All Profiles", value: "-1" };

  const filterOptions = [
    { label: "Technician", value: "tech" },
    { label: "Grader", value: "grader" },
    { label: "Monitor", value: "monitor" },
    { label: "Coordinator", value: "coordinator" },
    { label: "Administrator", value: "admin" },
  ];

  return (
    <CorcSelect
      id="role-select"
      containerStyles={{ width: "165px" }}
      name="role"
      options={[defaultOption, ...filterOptions]}
      onChange={(selectedOption) => props.setFilterRole(selectedOption.value)}
      defaultValue={defaultOption}
    />
  );
}
